module.exports = __webpack_public_path__ + "img/cattunnel40.4b44ebc0.jpg";